<i18n>
{
  "fr": {
    "content": "License du projet"
  },
  "en": {
    "content": "Project License"
  }
}
</i18n>

<template>
  <div>
    <h1>License</h1>
    <div>
      <p style="text-align: justify">
        <span v-html="$t('content')" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicensePage'
}
</script>
